import EventModel from '../../../utils/tracking/models';

export default function pingGTM() {
  const pageViewEvent = new EventModel();
  pageViewEvent.addToDataLayer('page_view');
}
